// extracted by mini-css-extract-plugin
module.exports = {"container":"SegmentedControlList_container__1-cCT","searchContainer":"SegmentedControlList_searchContainer__dTzSa"};